import React from "react";

import classNames from "classnames";
import {
  Button,
  Dialog,
  Classes,
  Intent,
  Callout,
  Card,
  FormGroup,
  InputGroup,
  H3,
  H4,
  Checkbox,
  Icon,
  Tooltip,
  Popover,
  PopoverInteractionKind,
  Tag,
  MenuItem
} from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import { Trans } from "react-i18next";
import i18n from "../../i18n";

import { authenticatedPostFetchWithResult } from "../../utils/AuthenticatedFetch";
import { getSetting } from "./InstallationSettings";

export default class UserCreator extends React.Component {
  constructor(props) {
    super(props);

    let groups;
    const groupStr = localStorage.getItem('groups');
    if (groupStr) {
      groups = JSON.parse(groupStr);
    } else
      groups = [];
    this.state = {
      isOpen: false,
      permAdmin: false,
      permFinancial: false,
      permActivity: false,
      permSpv: false,
      permCode: undefined,
      permBonitick: false,
      permExternAccessCtrl: false,
      showPassword: false,
      codeListGroup: [],
      codeMinLength: 3,
      codeMaxLength: 7,
      groups,
      login: "",
      pwd: "",
      errPwdSpecial: false,
      errPwdLength: false,
      errLoginShort: false
    }
  }

  handleOpen = () => {
    let groups;
    const groupStr = localStorage.getItem('groups');
    if (groupStr) {
      groups = JSON.parse(groupStr);
    } else
      groups = [];
    this.setState({ isOpen: true, groups });
  }

  handleClose = () => this.setState({
    isOpen: false,
    permAdmin: false,
    permFinancial: false,
    permActivity: false,
    permSpv: false,
    permCode: undefined,
    permBonitick: false,
    permExternAccessCtrl: false,
    pwd:"",
    codeListGroup: [],
    codeMinLength: 3,
    codeMaxLength: 7,
    groups: [],
    showPassword: false,
    errLoginShort: false,
    errPwdSpecial: false,
    errPwdLength: false,
    success: false
  });

  handleCreateUser = async () => {
    this.setState({ loading: true }, () => authenticatedPostFetchWithResult("/user",
      {
        login: this.state.login,
        pwd: this.state.pwd,
        permFinancial: this.state.permFinancial,
        permActivity: this.state.permActivity,
        permSPV: this.state.permSpv,
        permAdmin: this.state.permAdmin,
        permExternAccessCtrl: this.state.permExternAccessCtrl,
        permCode: this.state.codeListGroup.length > 0 ?{
          group: this.state.codeListGroup,
          codeMinLength: this.state.codeMinLength,
          codeMaxLength: this.state.codeMaxLength,
        }: undefined
      },
      (status, response) => {
        if (status === 200) {
          this.setState({
            success: true,
            errPwdSpecial: false,
            errPwdLength: false,
            errLoginShort: false,
            errLoginExist: false
          });
          this.props.onUpdate();
        } else {
          this.setState({
            errPwdSpecial: response.err.includes("new password not enough special char"),
            errPwdLength: response.err.includes("new password too short"),
            errLoginShort: response.err.includes("login is too short"),
            errLoginExist: response.err.includes("login already exists")
          });
        }
        this.setState({ loading: false });
      }));

  };

  manageGroupSelection(id) {
    let group = [...this.state.codeListGroup ];
    const index = group?.findIndex(val => val === id)
    if (index === -1) {
      group.push(id)
    } else {
      group.splice(index, 1);
    }
    this.setState({ codeListGroup: group })
  }

  groupIsSelected(id) {
    return this.state.codeListGroup?.includes(id);
  }
  getAccesCodeConfig() {
    const groups = [];
    for (const group of Object.keys(this.state.groups)) {
      groups.push(
        <Checkbox
        key={"g"+this.state.groups[group].id}
          label={<span>{this.state.groups[group].label}</span>}
          checked={this.groupIsSelected(group)}
          onChange={(cb) => { this.manageGroupSelection(group) }}
        />
      )
    }
    return (
    <>
      <Callout title={<Trans>Access code length</Trans>}>
        <Select 
            items={[3,4,5,7]}
            itemRenderer={(item, { select, modifiers }) => {
              return (
                <MenuItem
                  key={"UC_codeLengthMin" + item}
                  label={item}
                  text={item}
                  disabled={item > this.state.codeMaxLength}
                  onClick={(it)=> {
                    this.setState({codeMinLength: item});
                  }}
                />
              );
            }}
          >
            <Button
              text={i18n.t('Minimum length') + " " + this.state.codeMinLength }
              rightIcon="double-caret-vertical"
            />
          </Select>
          <Select 
            items={[3,4,5,7]}
            itemRenderer={(item, { select, modifiers }) => {
              return (
                <MenuItem
                  key={"UC_codeLengthMax" + item}
                  label={item}
                  text={item}
                  disabled={item < this.state.codeMinLength}
                  onClick={(it)=> {
                    this.setState({codeMaxLength: item});
                  }}
                />
              );
            }}
          >
            <Button
              text={i18n.t('Maximum length') + " " + this.state.codeMaxLength }
              rightIcon="double-caret-vertical"
            />
          </Select>
      </Callout >
      <Callout title={<Trans>list of groups</Trans>}>
        {groups}
      </Callout >
    </>);
  }

  render() {
    const lockButton = (
      <Tooltip content={this.state.showPassword ? <Trans>hide password</Trans> : <Trans>show password</Trans>}>
        <Button
          icon={this.state.showPassword ? "unlock" : "lock"}
          intent={Intent.WARNING}
          minimal={true}
          onClick={() => { this.setState({ showPassword: !this.state.showPassword }) }}
        />
      </Tooltip>
    );

    const classes = classNames(
      Classes.DIALOG_BODY
    );

    return (
      <div>
        <Button icon="new-person" onClick={this.handleOpen} text={<Trans>add a new user</Trans>} />
        <Dialog onClose={this.handleClose} isOpen={this.state.isOpen} style={{ transition: 'none' }}>
          <div className={classes}>
            <H3><Trans>add a new user</Trans></H3>

            <Callout hidden={!this.state.errLoginShort} intent="danger"><Trans>login is too short</Trans></Callout>
            <Callout hidden={!this.state.errLoginExist} intent="danger"><Trans>login already exists</Trans></Callout>
            <Callout hidden={!this.state.errPwdSpecial} intent="danger"><Trans>your new password must contain at least 2 special character</Trans></Callout>
            <Callout hidden={!this.state.errPwdLength} intent="danger"><Trans>your new password must contain at least 8 characters</Trans></Callout>
            <br />
            <div className={Classes.DIALOG_FOOTER} hidden={!this.state.success}>
              <Callout intent="success"><Trans>user created successfully</Trans></Callout>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <br />
                <Button icon='undo' intent={Intent.DANGER} disabled={this.state.loading} onClick={() => { this.handleClose(); this.props.onUpdate() }} />
              </div>
            </div>
            <div className={Classes.DIALOG_FOOTER} hidden={this.state.success}>
              <Card>
                <form>
                  <FormGroup label={<Trans>login</Trans>} labelFor="login-input">
                    <InputGroup id="login-input"
                      onChange={(ti) => { this.setState({ login: ti.target.value }); }}
                      intent={this.state.errPwdOld ? "danger" : "normal"}
                      type="text"
                    />
                  </FormGroup>
                  <FormGroup label={<Trans>password</Trans>} labelFor="password-input">
                    <InputGroup
                      id="password-input"
                      type={this.state.showPassword ? "text" : "password"}
                      onChange={(ti) => { this.setState({ pwd: ti.target.value }); }}
                      rightElement={lockButton}
                      intent={
                        (this.state.errPwdSpecial
                          || this.state.errPwdLength
                          || this.state.errPwdMissmatch
                        )
                          ? "danger" : "normal"}
                    />
                  </FormGroup>
                  <H4><Trans>permissions</Trans></H4>
                  <FormGroup>
                    {(localStorage.getItem('perm_financial_display') === "true") &&
                      <Checkbox
                        label={<span><Icon icon="document" /> <Trans>access to financial report</Trans></span>}
                        checked={this.state.isEnabled}
                        onChange={(cb) => { this.setState({ permFinancial: cb.target.checked }) }}
                      />}
                    {(localStorage.getItem('perm_activity_display') === "true") &&
                      <Checkbox
                        label={<span><Icon icon="timeline-line-chart" /> <Trans>access to activity report</Trans></span>}
                        checked={this.state.isEnabled}
                        onChange={(cb) => { this.setState({ permActivity: cb.target.checked }) }}
                      />}
                     {(localStorage.getItem('perm_custom_report_display') === "true") &&
                      <Checkbox
                        label={<span><Icon icon="timeline-bar-chart" /> <Trans>access to custom report</Trans></span>}
                        checked={this.state.isEnabled}
                        onChange={(cb) => { this.setState({ permCustomReport: cb.target.checked }) }}
                      />}
                    {(localStorage.getItem('perm_SPV_display') === "true") &&
                      <Checkbox
                        label={<span><Icon icon="drive-time" /> <Trans>access to the real time supervision</Trans></span>}
                        checked={this.state.isEnabled}
                        onChange={(cb) => { this.setState({ permSpv: cb.target.checked }) }}
                      />}
                      {(localStorage.getItem('perm_superadmin') === "true" || localStorage.getItem('perm_bonification') === "true") &&
                        <Checkbox
                          label={<span><Icon icon="tag" /> <Trans>access to Bonitick</Trans></span>}
                          checked={this.state.isEnabled}
                          onChange={(cb) => { this.setState({ permBonitick: cb.target.checked }) }}
                        />}
                      {((localStorage.getItem('perm_superadmin') === "true") || (localStorage.getItem('perm_extern_access_ctrl') === "true")) &&
                        <Checkbox
                          label={<span><Icon icon="changes" /> <Trans>access to external access control</Trans></span>}
                          checked={this.state.isEnabled}
                          onChange={(cb) => { this.setState({ permExternAccessCtrl: cb.target.checked }) }}
                        />}
                    <Tooltip content={<Trans>this user will be able to create other users</Trans>}>
                      <Checkbox
                        label={<span><Icon icon="crown" /> <Trans>administration permissions</Trans></span>}
                        checked={this.state.isEnabled}
                        onChange={(cb) => { this.setState({ permAdmin: cb.target.checked }) }}
                      />
                    </Tooltip>

                    {(getSetting("enable code") && localStorage.getItem('perm_SPV_display') === "true") &&
                      <>
                        <Popover
                          content={this.getAccesCodeConfig()}
                          placement="bottom"
                          interactionKind={PopoverInteractionKind.HOVER}
                          modifiers={{ arrow: { enabled: true } }}
                        >
                          <Button
                            icon='edit'
                            intent={Intent.NONE}
                          >
                            <Trans>select the group to manage access codes</Trans>
                          </Button>
                        </Popover>
                        <Tag>
                          {this.state.codeListGroup?.length} <Trans>Groups</Trans></Tag>
                      </>
                    }
                  </FormGroup>
                </form>
              </Card>
              <br />
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Button
                  icon='undo'
                  intent={Intent.DANGER}
                  disabled={this.state.loading}
                  onClick={this.handleClose}
                >
                  <Trans>cancel</Trans>
                </Button>
                <Button icon='upload'
                  loading={this.state.loading}
                  onClick={this.handleCreateUser}>
                  <Trans>send</Trans>
                </Button>
              </div>
            </div>
          </div>
        </Dialog >
      </div >
    )
  }
}
